import { isEmpty, isNil } from 'lodash';

import methodPromise from './method-promise-wrapper';

/**
 * Takes in the GeoJSON and returns the same geoJSON with the elevation added
 * as a 3rd coordinate in the array.
 * Gets the elevation data from a tif file in the server.
 *
 * @async
 * @param {string} missionId - The mission id, this looks for the dtm for that mission.
 * @param {object} geojson - The geojson object to return with elevations added.
 * @returns {object} The same geojson with the elevations added as a 3rd coordinate.
 */
export default async (missionId, geojson) => {
  if (isEmpty(geojson) || isNil(geojson)) throw new Error('The GeoJSON is Empty');

  try {
    const geojsonWithElevation = await methodPromise(
      'missions.addElevationToGeoJSON',
      missionId,
      geojson
    );
    return geojsonWithElevation;
  } catch (err) {
    throw new Error(err.message);
  }
};
